import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from "../context/AuthContext";
//import { AiOutlineBarcode } from "react-icons/ai";
import { usePrivate } from '../context/PrivateInfoContext';
import { Api } from '../services/Api';

function ConfirmaBoletoDialog(props){
    const { user } = useAuth();
    const { infoCobrancas } = usePrivate();
    const regEmail = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");
    const [confirmEmail,setConfirmEmail] = useState('');
    const footer = (
        <div className='paymentButton grid'>
                <Button 
                label='Continuar' 
                style={{fontFamily:'Branding-Regular, serif'}}
                onClick={()=>createPagamentoCDA()} />
        </div>
    )

    const createPagamentoCDA = () => {
        if(regEmail.test(confirmEmail) === true ){
        infoCobrancas.cobrancas.map((e) => validateEmail(e.cobranca_id));
        props.createBoleto();
        } else toast.error('Insira um email válido');
    }

    const cobrancasCDA = () => {
        let CDAS = ''
        //console.log(infoCobrancas.cobrancas.length)
        for(let i=0; i < infoCobrancas.cobrancas.length; i++){
            CDAS = CDAS.concat(infoCobrancas.cobrancas[i].cobranca_descricao.slice(-10),', ');
            //console.log(CDAS);
        }
        return (CDAS)
    }

    async function validateEmail(cobranca_id) {
        try { 
            await Api.post('/log',
            {other_value : confirmEmail,usuario_acao:'pagamento de CDA',cobranca_id:cobranca_id});
            props.close();
        } catch (error) {
          console.log(error);
        }
      }
    

    return(
        <Dialog 
        onHide={()=>props.close()}
        visible
        header="Confirmar"
        style={{
            heigth:window.innerHeight > 720 ? '40vh' : "90vh", 
            width:window.innerWidth > 720 ? '40vw': "100vw", 
            textAlign: 'left',
            borderRadius: '30px',
            fontFamily:'Branding-Bold, serif'
        }}
        className="confirmaBoletoDialog"
        draggable={false}
        footer={footer}
        >
            <div className='grid font-branding'>
                <h6>Prezado, Sr(a) <b>{user}</b>, após a confirmação dos pagamentos das custas/emolumentos, 
                em 72 horas úteis será efetivado a baixa do seu protesto.</h6>
                <div className='w-full mt-14'>
                    <span className='p-float-label'>
                        <InputText
                        type='email'
                        value={confirmEmail}
                        className="w-full"
                        onChange={(e)=>setConfirmEmail(e.target.value)}
                        />
                        <label><b>Confirme seu Email</b></label>
                    </span>
                </div>
            </div>
        </Dialog>    
    )
}

export default ConfirmaBoletoDialog